var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('p',{staticClass:"page-404_title"},[_vm._v("page not found")]),_c('el-button-group',[_c('el-button',{on:{"click":function($event){return _vm.$router.replace({ path: '/' })}}},[_vm._v("首页")]),_c('el-button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }